import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
    onAnalytics as originalAnalytics,
    ANALYTICS_TRIGGERS,
} from '@24i/nxg-sdk-smartott-shared/src/analytics';
import { useSessionId } from '@24i/nxg-sdk-smartott-shared/src/analytics/hooks/useSessionId';
import { useCampaignAnalytics } from '@24i/nxg-sdk-smartott-shared/src/analytics/hooks/useCampaign';
import { useEnrichedAnalytics } from '@24i/nxg-sdk-smartott-shared/src/analytics/hooks/useEnrichedAnalytics';
import { useExternalAccessValue } from '@24i/nxg-sdk-smartott-shared/src/hooks/subscriptions';
import { useAppConfigQuery } from '@24i/nxg-sdk-smartott-shared/src/hooks/query/useAppConfigQuery';

import { ConfirmPurchaseProps } from '../types';
import usePaymentPinProtection from '../../../../hooks/usePaymentsPinProtection';

export const useShared = ({
    selectedItem,
    closeModal,
    onPinValidationVisible,
}: ConfirmPurchaseProps) => {
    const { isActive: isPinProtectionActive } = usePaymentPinProtection();
    const { appSettings } = useAppConfigQuery();
    const { t } = useTranslation();
    const [isPinControlVisible, setPinControlVisible] = useState(false);
    const { sessionId } = useSessionId();
    const { campaignUrl, campaignCookie } = useCampaignAnalytics();
    const { getOfferId } = useExternalAccessValue();
    const onAnalytics = useEnrichedAnalytics(originalAnalytics);

    const handleOpenPinControl = (value: boolean) => {
        setPinControlVisible(value);
        onPinValidationVisible?.(value);
    };

    const onModalClose = () => {
        closeModal?.();
        setPinControlVisible(false);
    };

    const isPinVerificationActive =
        isPinProtectionActive && appSettings?.features?.pinProtection?.enabled;

    useEffect(() => {
        onAnalytics(ANALYTICS_TRIGGERS.SCENE_VIEW, {
            screen: t('analytics.documentTitle.purchase.step2'),
            sessionId,
            campaignUrl,
            campaignCookie,
        });
        onAnalytics(ANALYTICS_TRIGGERS.PURCHASE_START, selectedItem);
    }, []);

    return {
        offerId: getOfferId(selectedItem),
        isPinControlVisible,
        isPinVerificationActive,
        setPinControlVisible: handleOpenPinControl,
        closeModal: onModalClose,
    };
};
